document.addEventListener("DOMContentLoaded",function(){document.querySelector("#AjaxinateContainer")&&new Ajaxinate({container:"#AjaxinateContainer",pagination:"#AjaxinatePagination",loadingText:"Loading..."})});document.addEventListener("DOMContentLoaded",function(){const productForm=document.querySelector("form[action='/cart/add']");if(productForm){const variantSelects=productForm.querySelectorAll("select");variantSelects.forEach(select=>{select.addEventListener("change",function(){const selectedOption=this.options[this.selectedIndex];const available=selectedOption.getAttribute("data-available")==="true";const addToCartBtn=productForm.querySelector("[name='add']");if(addToCartBtn){addToCartBtn.disabled=!available;addToCartBtn.textContent=available?"Add to Cart":"Sold Out"}})})}});document.addEventListener("DOMContentLoaded",function(){const desc=document.querySelector(".product-description");if(desc&&desc.scrollHeight>200){desc.style.maxHeight="200px";desc.style.overflow="hidden";const btn=document.createElement("button");btn.textContent="Read More";btn.className="read-more-btn";btn.addEventListener("click",function(){desc.style.maxHeight="none";btn.classList.add("hidden")});desc.parentNode.insertBefore(btn,desc.nextSibling)}});


/* OIG CART SEPARATION - v10 */
(function() {
  var OIG_TAG = "old-is-gold";

  function buildOIGPopup(opts) {
    // opts: { msg, resolveCallback, shopLink, closeOnly }
    var style = document.createElement("style");
    style.textContent = [
      "@keyframes oigFadeIn{from{opacity:0;transform:scale(0.92)}to{opacity:1;transform:scale(1)}}@keyframes oigShine{0%{left:-100%}60%,100%{left:160%}}",
      ".oig-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.82);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);z-index:999999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif;}",
      ".oig-card{position:relative;background:linear-gradient(160deg,#2a2a2a 0%,#111 40%,#0a0a0a 70%,#1a1a1a 100%);border-radius:18px;max-width:380px;width:100%;text-align:center;animation:oigFadeIn 0.4s cubic-bezier(0.22,1,0.36,1);box-shadow:0 0 0 1px rgba(160,120,32,0.6),0 0 0 3px #111,0 0 0 4px rgba(201,168,76,0.8),inset 0 2px 0 rgba(255,255,255,0.18),inset 0 -2px 0 rgba(0,0,0,0.7),inset 2px 0 0 rgba(255,255,255,0.06),inset -2px 0 0 rgba(0,0,0,0.5),0 0 80px rgba(201,168,76,0.35),0 30px 90px rgba(0,0,0,0.95);overflow:visible;}",
      ".oig-card::before{content:'';position:absolute;top:0;left:0;right:0;height:52%;pointer-events:none;background:linear-gradient(180deg,rgba(255,255,255,0.22) 0%,rgba(255,255,255,0.12) 20%,rgba(255,255,255,0.04) 60%,transparent 100%);border-radius:18px 18px 60% 60%/18px 18px 30px 30px;pointer-events:none;z-index:3;}",
      ".oig-card::after{content:'';position:absolute;top:-10%;left:-20%;width:60%;height:75%;pointer-events:none;background:linear-gradient(125deg,rgba(255,255,255,0.12) 0%,rgba(255,255,255,0.05) 30%,transparent 65%);border-radius:50%;pointer-events:none;z-index:2;transform:rotate(-15deg);}",
      ".oig-badge{position:absolute;top:-4px;left:16px;width:72px;height:80px;display:flex;flex-direction:column;align-items:center;justify-content:center;background:radial-gradient(circle at 40% 30%,#f5d878,#c9a84c 40%,#8a6010 100%);clip-path:polygon(0 0,100% 0,100% 80%,50% 100%,0 80%);box-shadow:inset 0 2px 4px rgba(255,255,255,0.3),0 4px 12px rgba(0,0,0,0.5);z-index:2;}",
      ".oig-badge-text{font-size:9px;font-weight:900;color:#1a1a1a;letter-spacing:1px;text-transform:uppercase;line-height:1.2;text-align:center;padding:0 6px;text-shadow:0 1px 0 rgba(255,255,255,0.3);}",
      ".oig-badge-stars{font-size:8px;color:#1a1a1a;letter-spacing:1px;margin-top:2px;}",
      ".oig-close{position:absolute;top:12px;right:12px;width:30px;height:30px;border-radius:50%;z-index:10;border:1.5px solid #c9a84c;background:rgba(0,0,0,0.6);color:#c9a84c;font-size:14px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;transition:background 0.2s;}",
      ".oig-close:hover{background:#c9a84c;color:#1a1a1a;}",
      ".oig-inner{padding:17px 15px 15px;position:relative;z-index:4;background:linear-gradient(180deg,rgba(255,255,255,0.04) 0%,rgba(255,255,255,0.01) 40%,transparent 100%);border-radius:0 0 14px 14px;}",
      ".oig-deco{font-size:11px;color:#c9a84c;letter-spacing:4px;margin-bottom:2px;opacity:0.8;}",
      ".oig-crown{font-size:20px;display:block;margin-bottom:1px;}",
      ".oig-laurel{display:flex;align-items:center;justify-content:center;gap:5px;margin:0 auto 2px;}",
      ".oig-laurel-branch{font-size:17px;color:#c9a84c;filter:drop-shadow(0 0 6px rgba(201,168,76,0.6));}",
      ".oig-laurel-branch.right{transform:scaleX(-1);}",
      ".oig-title{font-size:36px;font-weight:900;letter-spacing:2px;text-transform:uppercase;line-height:0.95;background:linear-gradient(180deg,#fff9e0 0%,#f5d878 25%,#c9a84c 55%,#8a6010 80%,#c9a84c 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;filter:drop-shadow(0 2px 8px rgba(201,168,76,0.4));margin:0;}",
      ".oig-is{font-size:clamp(10px,3vw,13px);font-weight:400;letter-spacing:8px;display:block;background:linear-gradient(180deg,#f5d878,#c9a84c);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;margin:2px 0;}",
      ".oig-stars{font-size:10px;color:#c9a84c;letter-spacing:3px;margin:3px 0 6px;}",
      ".oig-banner{background:linear-gradient(90deg,rgba(201,168,76,0.08),rgba(201,168,76,0.18),rgba(201,168,76,0.08));border-top:1px solid rgba(201,168,76,0.4);border-bottom:1px solid rgba(201,168,76,0.4);padding:6px 12px;margin:0 0 8px;}",
      ".oig-banner p{margin:0;font-size:11px;font-weight:700;color:#c9a84c;letter-spacing:1.5px;text-transform:uppercase;line-height:1.5;}",
      ".oig-sub{font-size:13px;color:#9a9a9a;line-height:1.6;margin:0 0 10px;padding:0 6px;}",
      ".oig-divider{display:flex;align-items:center;gap:6px;margin:0 auto 8px;width:80%;}",
      ".oig-divider-line{flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(201,168,76,0.4),transparent);}",
      ".oig-divider-gem{color:#c9a84c;font-size:10px;}",
      ".oig-icons{display:flex;justify-content:center;align-items:flex-end;gap:0;margin:0 0 12px;border-top:1px solid rgba(201,168,76,0.15);border-bottom:1px solid rgba(201,168,76,0.15);padding:7px 0;}",
      ".oig-icon-item{flex:1;display:flex;flex-direction:column;align-items:center;gap:4px;padding:0 4px;border-right:1px solid rgba(201,168,76,0.15);}",
      ".oig-icon-item:last-child{border-right:none;}",
      ".oig-icon-item span:first-child{font-size:22px;filter:sepia(1) saturate(2) hue-rotate(10deg) brightness(0.85);}",
      ".oig-icon-item span:last-child{font-size:9px;color:#7a7a7a;letter-spacing:0.5px;text-transform:uppercase;}",
      ".oig-btn-later{display:block;width:100%;padding:8px 20px;background:linear-gradient(180deg,rgba(255,255,255,0.15) 0%,rgba(255,255,255,0.06) 45%,rgba(0,0,0,0.15) 100%);color:#c0c0c0;border:1px solid rgba(255,255,255,0.28);border-radius:10px;font-size:12px;font-weight:600;letter-spacing:2px;text-transform:uppercase;cursor:pointer;transition:all 0.3s;box-shadow:inset 0 1px 0 rgba(255,255,255,0.3),inset 0 -2px 0 rgba(0,0,0,0.4),inset 1px 0 0 rgba(255,255,255,0.08),inset -1px 0 0 rgba(0,0,0,0.15),0 4px 16px rgba(0,0,0,0.5);text-shadow:0 1px 3px rgba(0,0,0,0.7);position:relative;overflow:hidden;}",
      ".oig-btn-later:hover{color:#f5d878;border-color:rgba(201,168,76,0.55);background:linear-gradient(180deg,rgba(201,168,76,0.18) 0%,rgba(201,168,76,0.08) 45%,rgba(0,0,0,0.1) 100%);box-shadow:inset 0 1px 0 rgba(255,255,255,0.35),inset 0 -2px 0 rgba(0,0,0,0.3),0 4px 20px rgba(201,168,76,0.25);text-shadow:0 0 12px rgba(201,168,76,0.6);}",
      "@media(max-width:380px){.oig-inner{padding:12px 10px 10px;}.oig-title{font-size:40px;}.oig-badge{width:60px;height:68px;}.oig-badge-text{font-size:8px;}.oig-icon-item span:first-child{font-size:20px;}}"
    ].join("");
    document.head.appendChild(style);

    var overlay = document.createElement("div");
    overlay.className = "oig-overlay";

    var card = document.createElement("div");
    card.className = "oig-card";
    card.innerHTML = [
      "<div class='oig-badge'><span class='oig-badge-text'>LIMITED STOCK</span><span class='oig-badge-stars'>★ ★ ★</span></div>",
      "<button class='oig-close' aria-label='Close'>&#x2715;</button>",
      "<div class='oig-inner'>",
        "<div class='oig-deco'><span class='oig-crown'>&#x1F451;</span>&#10022; &#10022; &#10022;</div>",
        "<div class='oig-laurel'>",
          "<span class='oig-laurel-branch'>&#x1F33F;</span>",
          "<div>",
            "<h2 class='oig-title'>OLD<span class='oig-is'>— is —</span>GOLD</h2>",
          "</div>",
          "<span class='oig-laurel-branch right'>&#x1F33F;</span>",
        "</div>",
        "<div class='oig-stars'>★ ★ ★ ★ ★</div>",
        "<div class='oig-banner'><p>LIMITED STOCK CLEARANCE DEALS ON<br>SELECTED MUSICAL INSTRUMENTS &amp; PRO AUDIO GEAR.</p></div>",
        "<p class='oig-sub'>" + (opts.msg || "Discover special prices on selected products.<br>Stock is limited and available on a first-come, first-served basis.") + "</p>",
        "<div class='oig-divider'><div class='oig-divider-line'></div><span class='oig-divider-gem'>&#x2756;</span><div class='oig-divider-line'></div></div>",
        "<div class='oig-icons'>",
          "<div class='oig-icon-item'><span>&#x1F3B8;</span><span>Guitar</span></div>",
          "<div class='oig-icon-item'><span>&#x1F3B9;</span><span>Keys</span></div>",
          "<div class='oig-icon-item'><span>&#x1F941;</span><span>Drums</span></div>",
          "<div class='oig-icon-item'><span>&#x1F50A;</span><span>Speaker</span></div>",
          "<div class='oig-icon-item'><span>&#x1F3A4;</span><span>Mic</span></div>",
        "</div>",
                "<button class='oig-btn-later'>GOT IT</button>",
      "</div>"
    ].join("");

    function dismiss(doResolve) {
      document.body.removeChild(overlay);
      document.head.removeChild(style);
      sessionStorage.setItem("oig_popup_seen", "1");
      if (doResolve && opts.resolveCallback) {
        opts.resolveCallback(new Response(JSON.stringify({items:[]}), {status:200,headers:{"Content-Type":"application/json"}}));
      }
    }

    card.querySelector(".oig-close").onclick    = function() { dismiss(true); };
    card.querySelector(".oig-btn-later").onclick = function() { dismiss(true); };
    overlay.onclick = function(e) { if (e.target === overlay) dismiss(true); };

    overlay.appendChild(card);
    document.body.appendChild(overlay);
  }

  function showAlert(addingOIG, resolve) {
    var msg = addingOIG
      ? "Old is Gold items are clearance products and must be purchased separately. Please complete your current order first."
      : "Clearance items must be checked out separately. Please complete your clearance order first, or start a new cart.";
    buildOIGPopup({ msg: msg, resolveCallback: resolve });
  }

  // Normalize tags to array regardless of format
  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === "string" && tags.length > 0) return tags.split(",").map(function(t) { return t.trim(); });
    return [];
  }

  // Check if a tags array contains the OIG tag
  function hasOIGTag(tags) {
    return normalizeTags(tags).some(function(t) { return t.trim().toLowerCase() === OIG_TAG; });
  }

  // Fetch product tags by handle - the most reliable method
  function getTagsByHandle(handle) {
    if (!handle) return Promise.resolve([]);
    return fetch("/products/" + handle + ".js")
      .then(function(r) { return r.json(); })
      .then(function(p) { return normalizeTags(p.tags); })
      .catch(function() { return []; });
  }

  // Given a variant ID, determine if it belongs to an OIG product
  // Uses multiple fallback strategies
  function isOIG(variantId) {
    // Strategy 1: Check window.cartmax_product (fast path, works on product pages)
    try {
      var cp = window.cartmax_product;
      if (cp && cp.product) {
        var pd = cp.product;
        var variants = pd.variants || cp.productVariants || [];
        var idStr = String(variantId);
        if (variants.some(function(v) { return String(v.id) === idStr; })) {
          var result = hasOIGTag(pd.tags);
          console.log("[OIG v10] isOIG via cartmax_product:", result, "handle:", pd.handle);
          return Promise.resolve(result);
        }
      }
    } catch(e) {}

    // Strategy 2: Fetch /variants/{id}.js, use v.name to search for product handle
    console.log("[OIG v10] isOIG: fetching /variants/" + variantId + ".js");
    return fetch("/variants/" + variantId + ".js")
      .then(function(r) { return r.json(); })
      .then(function(v) {
        console.log("[OIG v10] variant name:", v && v.name);
        // v.name is "Product Title - Variant Title" — strip variant suffix to get product name
        var productName = v && v.name ? v.name.split(" - ").slice(0, -1).join(" - ") || v.name : null;
        if (!productName) {
          console.log("[OIG v10] no name on variant, returning []");
          return [];
        }
        console.log("[OIG v10] searching for:", productName);
        return fetch("/search/suggest.json?q=" + encodeURIComponent(productName) + "&resources[type]=product&resources[limit]=1")
          .then(function(r) { return r.json(); })
          .then(function(d) {
            var products = d && d.resources && d.resources.results && d.resources.results.products;
            if (products && products.length > 0 && products[0].handle) {
              console.log("[OIG v10] found handle:", products[0].handle);
              return getTagsByHandle(products[0].handle);
            }
            console.log("[OIG v10] search no results for:", productName);
            return [];
          })
          .catch(function() { return []; });
      })
      .then(function(tags) {
        var result = hasOIGTag(tags);
        console.log("[OIG v10] isOIG final result:", result, "tags:", JSON.stringify(tags).substring(0, 100));
        return result;
      })
      .catch(function(e) {
        console.log("[OIG v10] isOIG error:", e);
        return false;
      });
  }

  // Check if cart has a conflict with the item being added
  function cartHasConflict(addingOIG) {
    return fetch("/cart.js")
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var items = cart.items || [];
        console.log("[OIG v10] cart items:", items.map(function(i) { return {handle: i.handle, title: i.title}; }));
        if (items.length === 0) return false;
        return Promise.all(items.map(function(item) {
          return getTagsByHandle(item.handle);
        })).then(function(allTags) {
          var anyOIG = allTags.some(function(tags) { return hasOIGTag(tags); });
          var anyReg = allTags.some(function(tags) { return !hasOIGTag(tags); });
          console.log("[OIG v10] addingOIG=" + addingOIG + " anyOIG=" + anyOIG + " anyReg=" + anyReg);
          return (addingOIG && anyReg) || (!addingOIG && anyOIG);
        });
      })
      .catch(function(e) {
        console.log("[OIG v10] cartHasConflict error:", e);
        return false;
      });
  }

  // Extract variant ID from cart/add request body
  function getId(body) {
    if (!body) return null;
    if (typeof body === "string") {
      try { var j = JSON.parse(body); if (j && j.id) return String(j.id); } catch(e) {}
      try { var p = new URLSearchParams(body); var v = p.get("id"); if (v) return v; } catch(e) {}
    }
    if (body && typeof body.get === "function") {
      var fd = body.get("id"); if (fd) return String(fd);
    }
    return null;
  }

  // Intercept fetch()
  var _origFetch = window.fetch;
  window.fetch = function(url, opts) {
    var args = arguments;
    if (typeof url === "string" && url.indexOf("/cart/add") !== -1) {
      var body = opts && opts.body;
      var vid = getId(body);
      console.log("[OIG v10] fetch /cart/add intercepted, vid=" + vid);
      if (vid) {
        return isOIG(vid).then(function(adding) {
          console.log("[OIG v10] adding product isOIG=" + adding);
          return cartHasConflict(adding).then(function(conflict) {
            if (conflict) {
              return new Promise(function(resolve) {
                showAlert(adding, resolve);
              });
            }
            return _origFetch.apply(window, args);
          });
        }).catch(function() {
          return _origFetch.apply(window, args);
        });
      }
    }
    return _origFetch.apply(window, args);
  };

  // Intercept XMLHttpRequest (fallback for XHR-based cart adds)
  var _xOpen = XMLHttpRequest.prototype.open;
  var _xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(m, u) {
    this._oigUrl = u;
    return _xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    var xhr = this;
    if (xhr._oigUrl && xhr._oigUrl.indexOf("/cart/add") !== -1) {
      var vid = getId(body);
      console.log("[OIG v10] XHR /cart/add intercepted, vid=" + vid);
      if (vid) {
        isOIG(vid).then(function(adding) {
          return cartHasConflict(adding).then(function(conflict) {
            if (conflict) { showAlert(adding); return; }
            _xSend.apply(xhr, [body]);
          });
        }).catch(function() { _xSend.apply(xhr, [body]); });
        return;
      }
    }
    return _xSend.apply(this, [body]);
  };



  // Standalone OIG promotional popup — once per session, 3s delay
  if (!sessionStorage.getItem("oig_popup_seen")) {
    setTimeout(function() {
      if (!sessionStorage.getItem("oig_popup_seen") && !document.querySelector(".oig-overlay")) {
        buildOIGPopup({ resolveCallback: null });
      }
    }, 3000);
  }

  console.log("[OIG v10] Cart separation script loaded.");
})();